import { FlowRouteType } from '~/utils/flow.utils';
import { TBuilderQueryParams } from '~/types/builder.types';

export type TFlowUrlParams = {
    flowId: string;
    forceRoute?: FlowRouteType;
    queryParams?: TBuilderQueryParams;
    openInANewTab?: boolean;
};

export const getFlowUrl = ({
    flowId,
    forceRoute,
    queryParams,
    openInANewTab = false
}: TFlowUrlParams): string => {
    let route = `/flow/${flowId}`;
    // when using angular navigation, the path is automatically resolved from /preview to /edit/ preview,
    // however, when using react navigation, or when navigating to a new tab, the path is not resolved automatically.
    if (forceRoute) {
        route +=
            forceRoute === FlowRouteType.preview
                ? `/edit/${forceRoute}`
                : `/${forceRoute}`;
    }

    if (queryParams) {
        route += `?${new URLSearchParams(queryParams).toString()}`;
    }

    return openInANewTab ? `/app${route}` : route;
};
